// extracted by mini-css-extract-plugin
export default {"industryModel":"styles_industryModel__49J2F","boxModel":"styles_boxModel__AKpbz","cross":"styles_cross__8JAHe"};